import React from 'react'
import './App.css'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Dashboard from './Components/Dashboard.js'
import About from './Components/About.js'
import Start from './Components/Start.js'

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
    <div className="App">
    <Route path="/" exact component={Start} />
    <Route path="/Dashboard" exact component={Dashboard} />
    <Route path="/About" component={About} />
    </div>
    </Router>
  )
}

export default App;
